import React from "react";
import { useQuickCreate } from "../context/QuickCreateContext";
import { VehicleAddEditDialog } from "../pages/vehicle/VehicleAddEditDialog";
import { SalesCustomerAddEditDialog } from "../pages/sales-customers/SalesCustomerAddEditDialog";
import { SupplierAddEditDialog } from "../pages/suppliers/SupplierAddEditDialog";

/**
 * QuickCreateDialogs - Renders create dialogs that can be opened from anywhere in the app
 * This component should be mounted at the app level (in MasterLayout or App.tsx)
 *
 * When a quick action with createEntity is clicked, it opens the dialog here
 * instead of navigating to the entity's page.
 */
export const QuickCreateDialogs: React.FC = () => {
  const { activeDialog, closeCreateDialog } = useQuickCreate();

  return (
    <>
      {/* Vehicle Create Dialog */}
      <VehicleAddEditDialog
        show={activeDialog === "vehicle"}
        handleClose={closeCreateDialog}
        id={null}
      />

      {/* Sales Customer Create Dialog */}
      <SalesCustomerAddEditDialog
        show={activeDialog === "sales-customer"}
        handleClose={closeCreateDialog}
        id={null}
      />

      {/* Supplier Create Dialog */}
      <SupplierAddEditDialog
        show={activeDialog === "supplier"}
        handleClose={closeCreateDialog}
        id={null}
      />
    </>
  );
};
